// THE TWO BUILT-INS AN OLDER PHONE'S BROWSER LACKS AND THIS BUNDLE CALLS (2026-10-26, docs/FORM-AUDIT-2026-10-26.md).
//
// Create React App compiles the form's syntax down to the browsers it lists and adds no built-ins of its own (no
// react-app-polyfill is imported), so a function a browser does not have is a crash on that browser. One was measured: an
// iPhone on iOS 12 (Safari 12.0, which has no `Object.fromEntries`) threw "Object.fromEntries is not a function" in the first
// render, from day.ts's product-zone day, and the page never drew; all four such visits in the beacon from 2026-09-09 to 10-25
// ended there, none signed. The other is `String.prototype.replaceAll` (Safari 13.1), which styled-components calls on a style
// with a self-reference. Each is put in place only where the browser has none, so every other phone runs the browser's own.
// Imported FIRST by index.tsx, before anything that could call either.

type Entries = Iterable<readonly [PropertyKey, unknown]>;

export function installPolyfills(target: { Object: ObjectConstructor; String: StringConstructor } = { Object, String }): void {
  const O = target.Object as unknown as { fromEntries?: (entries: Entries) => Record<PropertyKey, unknown> };
  if (typeof O.fromEntries !== "function") {
    Object.defineProperty(target.Object, "fromEntries", {
      configurable: true,
      writable: true,
      value: function fromEntries(entries: Entries): Record<PropertyKey, unknown> {
        const out: Record<PropertyKey, unknown> = {};
        for (const [key, value] of Array.from(entries)) out[key as string] = value;
        return out;
      },
    });
  }
  const proto = target.String.prototype as unknown as { replaceAll?: (search: string | RegExp, replacement: string) => string };
  if (typeof proto.replaceAll !== "function") {
    Object.defineProperty(target.String.prototype, "replaceAll", {
      configurable: true,
      writable: true,
      value: function replaceAll(this: string, search: string | RegExp, replacement: string): string {
        if (search instanceof RegExp) {
          if (!search.global) throw new TypeError("replaceAll must be called with a global RegExp");
          return String(this).replace(search, replacement);
        }
        return String(this).split(String(search)).join(replacement);
      },
    });
  }
}

installPolyfills();
